import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=3b94800a"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports